import React from 'react';
import './App.css';

import LogoHeader from './logo-header/LogoHeader.component';
import ContentArea from './content-area/ContentArea.component';

function App() {

  return (
    <div className="App">
      <LogoHeader />
      <div className="body-container">
        <ContentArea />
      </div>
    </div>
  );
}

export default App;
